// eslint-disable-next-line import/prefer-default-export
export const logError = (error: Error) => {
  console.warn(error);
};
